import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { safeGet } from '../../../../core/util/object';

const Root = styled.div`
  display: flex;
  align-items: center;
`;

const Icon = styled.div`
  svg {
    display: inline-block;
    vertical-align: middle;
  }
`;

class IconWrapper extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: (props, propName, componentName) => {
      if (Array.isArray(props[propName]) && props[propName].length === 2) {
        const [child1] = props[propName];
        if (safeGet(child1)`props.src`) return null;
      }

      return new Error(
        `Invalid prop '${propName}' supplied to '${componentName}'. ` +
          'The first child should be the image icon component'
      );
    },
  };

  render() {
    const {
      children: [icon, label],
      className,
    } = this.props;

    return (
      <Root className={className}>
        <Icon>{icon}</Icon>
        {label}
      </Root>
    );
  }
}

export default IconWrapper;
